import React, { Component } from 'react'
import { Switch, Route, Link, Redirect } from 'react-router-dom'

import './App.css'

import { InfoPanelList } from './components/InfoPanelList.js'
import { InfoPanelPage } from './components/InfoPanelPage.js'
import { InfoPanelControl } from './components/InfoPanelControl.js'
import { InfoPanelEditPage } from './components/InfoPanelEditPage.js'

class App extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/" component={InfoPanelList} />
                <Route path="/control" component={InfoPanelControl} />
                <Route path="/:panelId/edit" component={InfoPanelEditPage} />
                <Route path="/:panelId" component={InfoPanelPage} />

            </Switch>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js